<template>
  <Card
    :class="$style.card"
    :hasNoBorder="false"
  >
    <template v-slot:header>
      <HeadingExtraSmall>
        {{ header }}
      </HeadingExtraSmall>
    </template>
    <template v-slot:body>
      <div>
        <slot name="addButton" />
        <ItemListPagination
          v-if="shouldShowTable"
          :columns="columns"
          :isLoading="false"
          :itemComponent="$options.KeyTableRow"
          :rowsPerPage="100"
          :sortBy="sortBy"
          :sortDirection="sortDirection"
          :tableData="keysToDisplay"
          :totalCount="numberOfKeys"
          @pageChange="handleChangePage"
          @sortColumn="handleSortColumn"
        />
        <slot
          v-else
          name="emptyState"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import {
  Card, Constants, HeadingExtraSmall, ItemListPagination,
} from '@jumpcloud/ui-components';
import { getColumns, getHeader } from 'client/systemusers/UserDetails/WebAuthnKeys/webAuthnHelpers';
import { reverse, sortBy } from 'lodash';
import KeyTableRow from 'client/systemusers/UserDetails/WebAuthnKeys/KeyTableRow.vue';

const { sortDirections } = Constants;

export default {
  name: 'KeyTableView',

  components: {
    Card,
    HeadingExtraSmall,
    ItemListPagination,
  },

  props: {
    keyType: {
      type: String,
      required: true,
    },
    webAuthnKeys: {
      type: Array,
      required: true,
    },
  },

  KeyTableRow,

  data() {
    return {
      sortBy: 'name',
      sortDirection: sortDirections.ascending,
    };
  },

  computed: {
    columns() {
      return getColumns(this.keyType);
    },

    header() {
      return getHeader(this.keyType);
    },

    keysToDisplay() {
      const sortedArray = sortBy(this.webAuthnKeys, this.sortBy);
      const isAscending = this.sortDirection === sortDirections.ascending;

      return isAscending ? sortedArray : reverse(sortedArray);
    },

    numberOfKeys() {
      return this.webAuthnKeys.length;
    },

    shouldShowTable() {
      return !!this.numberOfKeys;
    },
  },

  methods: {
    handleChangePage() {},

    handleSortColumn({ dataFieldName, sortDirection }) {
      this.sortBy = dataFieldName;
      this.sortDirection = sortDirection;
    },
  },
};
</script>

<style module>
.card {
  margin: var(--jc-spacer-large) auto;
}
</style>
